/**
 * DraftsEmptyState — empty-state copy for the drafts inbox (Phase X.3.1).
 *
 * Empty in X.3.1 because the `ai_drafts` table doesn't exist yet (lands
 * X.3.2). Copy is role-neutral / tenant-neutral per Constraint 3.
 */

import { type ReactNode } from 'react';

export function DraftsEmptyState(): ReactNode {
  return (
    <div className="text-center py-8" data-testid="drafts-empty-state">
      <p className="text-sm font-medium text-ink-soft max-w-md mx-auto leading-relaxed">
        Save a draft from any tool and you&rsquo;ll find it here when you come back.
      </p>
    </div>
  );
}
